import React, { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

// ===================
// Imported Optimized Images from src/assets-optimized
// Imported so we can use image-webpack-loader for image optimizations
// Run the node optimize-images.js script to convert images in src/assets to webp
// ===================

// 2025-MichaelGaryDean_FreddySpeer
// 2025-MichaelGaryDean_FreddySpeer
import MGD_FS_017 from '../assets-optimized/projects/2025-MichaelGaryDean_FreddySpeer/2025-04-24-Micheal_Gary_Dean_SebastienRoy_017.webp';
import MGD_FS_035 from '../assets-optimized/projects/2025-MichaelGaryDean_FreddySpeer/2025-04-24-Micheal_Gary_Dean_SebastienRoy_035.webp';
import MGD_FS_SAT60 from '../assets-optimized/projects/2025-MichaelGaryDean_FreddySpeer/SubstratFrederiqueMenard-Aubin_SAT-60.webp';
import MGD_FS_SAT61 from '../assets-optimized/projects/2025-MichaelGaryDean_FreddySpeer/SubstratFrederiqueMenard-Aubin_SAT-61.webp';
import MGD_FS_SAT66 from '../assets-optimized/projects/2025-MichaelGaryDean_FreddySpeer/SubstratFrederiqueMenard-Aubin_SAT-66.webp';
import MGD_FS_SAT71 from '../assets-optimized/projects/2025-MichaelGaryDean_FreddySpeer/SubstratFrederiqueMenard-Aubin_SAT-71.webp';
import MGD_FS_SAT85 from '../assets-optimized/projects/2025-MichaelGaryDean_FreddySpeer/SubstratFrederiqueMenard-Aubin_SAT-85.webp';
import MGD_FS_SAT86 from '../assets-optimized/projects/2025-MichaelGaryDean_FreddySpeer/SubstratFrederiqueMenard-Aubin_SAT-86.webp';

// 2025-Unsettled
import US_006 from '../assets-optimized/projects/2025-Unsettled/_2025-02-15-Cymatiques3_SebastienRoy_006.webp';
import US_011 from '../assets-optimized/projects/2025-Unsettled/_2025-02-15-Cymatiques3_SebastienRoy_011.webp';
import US_032 from '../assets-optimized/projects/2025-Unsettled/_2025-02-15-Cymatiques3_SebastienRoy_032.webp';
import US_035 from '../assets-optimized/projects/2025-Unsettled/_2025-02-15-Cymatiques3_SebastienRoy_035.webp';
import US_023 from '../assets-optimized/projects/2025-Unsettled/_2025-02-15-Cymatiques3_SebastienRoy_023.webp';
import US_013 from '../assets-optimized/projects/2025-Unsettled/_2025-02-15-Cymatiques3_SebastienRoy_013.webp';

// 2024-CEM (Converted to .webp)
import CEMMGDCoverShot from '../assets-optimized/projects/2024-CEM/CEM-MGD_CoverShot.webp';
import CEMP1084386 from '../assets-optimized/projects/2024-CEM/CEM-P1084386.webp';
import CEMStills from '../assets-optimized/projects/2024-CEM/CEM_Stills__1.1.24.webp';
import CEM3gars from '../assets-optimized/projects/2024-CEM/CEM-3gars.webp';
import CEMP1084604 from '../assets-optimized/projects/2024-CEM/CEM-P1084604.webp';
import CEMP1084477 from '../assets-optimized/projects/2024-CEM/CEM-P1084477.webp';

// 2024-Forever_Meditations
import FM_MUTEK24_001 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MUTEK24_20230822_Michael-Gary-Dean_Bruno-Aiello-Destombes_001.webp';
import FM_MUTEK24_007 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MUTEK24_20230822_Michael-Gary-Dean_Bruno-Aiello-Destombes_007.webp';
import FM_MUTEK24_005 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MUTEK24_20230822_Michael-Gary-Dean_Bruno-Aiello-Destombes_005.webp';
import FM_MG_9175 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MG_9175_SebastienRoy.webp';
import FM_MG_9229 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MG_9229_SebastienRoy-.webp';
import FM_MG_9344 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MG_9344_SebastienRoy-.webp';
import FM_MG_9349 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MG_9349_SebastienRoy-.webp';
import FM_MG_9365 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MG_9365_SebastienRoy-.webp';
import FM_MUTEK24_016 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MUTEK24_20230822_Michael-Gary-Dean_Bruno-Aiello-Destombes_016.webp';
import FM_MUTEK24_006 from '../assets-optimized/projects/2024-Forever_Meditations/FM_MUTEK24_20230822_Michael-Gary-Dean_Bruno-Aiello-Destombes_006.webp';
import FM_DSCF1480 from '../assets-optimized/projects/2024-Forever_Meditations/FM_DSCF1480.webp';
import FM_DSCF1371 from '../assets-optimized/projects/2024-Forever_Meditations/FM_DSCF1371.webp';
import FM_PhiCentreMixing2Vertical2 from '../assets-optimized/projects/2024-Forever_Meditations/FM_Phi-Centre-Mixing-02-Vertical2.webp';
import FM_DSCF1414 from '../assets-optimized/projects/2024-Forever_Meditations/FM_DSCF1414.webp';
import FM_StudioRehearsalVertical3 from '../assets-optimized/projects/2024-Forever_Meditations/FM_Studio-Rehearsal-06-vertical3.webp';

// 2021-Abandoned_Pianos
import AP_ABANDONED_PIANS_1 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_ABANDONED-PIANOS_BrunoDestombes_DSC09422_beauty.webp';
import AP_ABANDONED_PIANS_2 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_ABANDONED-PIANOS_BrunoDestombes_DSC09469.00009469.webp';
import AP_ABANDONED_PIANS_3 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_ABANDONED-PIANOS_BrunoDestombes_DSC.00009332.webp';
import AP_ABANDONED_PIANS_4 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_ABANDONED-PIANOS_BrunoDestombes_DSC09310.00009310-.webp';
import AP_MG_5753 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_MG_5753_SebastienRoy-M.webp';
import AP_MG_5771 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_MG_5771_SebastienRoy-.webp';
import AP_PT200120 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_PT200120_DSC9328.webp';
import AP_Promo06 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_Abandoned_Pianos_Promo_still06.webp';
import AP_Promo09 from '../assets-optimized/projects/2021-Abandoned_Pianos/AP_Abandoned_Pianos_Promo_still09.webp';

// 2020-Frozen_Music
import FM_FrozenMusic_01 from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_211029_FROZEN_MUSIC_Cadie_DD_Michael_GD_IMMERSIVE_01.webp';
import FM_FrozenMusic_IMG7182 from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_IMG_7182.webp';
import FM_FrozenMusic_02 from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_211029_FROZEN_MUSIC_Cadie_DD_Michael_GD_IMMERSIVE_02.webp';
import FM_FrozenMusic_03 from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_211029_FROZEN_MUSIC_Cadie_DD_Michael_GD_IMMERSIVE_03-2048x1365-1.webp';
import FM_FrozenMusic_Portrait from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_211029_FROZEN_MUSIC_Cadie_DD_Michael_GD_PORTRAIT-scaled.webp';
import FM_FrozenMusic_IMG1508 from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_IMG_1508.webp';
import FM_FrozenMusic_119125342 from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_119125342_10159091244883521_5909070215152068613_o.webp';
import FM_FrozenMusic_EhyEq from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_EhyEq-jXsAE1NGL.webp';
import FM_FrozenMusic_SONCIA from '../assets-optimized/projects/2020-Frozen_Music/FM_FrozenMusic_SONCIA_WAVE_08.webp';

// 2019-Membrane
import Membrane_Push1Stop from '../assets-optimized/projects/2019-Membrane/Membrane_Push1Stop_Wiklow__Eufonic19_04_fot_Dani-Canto.webp';
import Membrane_WiklowPush1Stop from '../assets-optimized/projects/2019-Membrane/Membrane_WiklowPush1Stop_SonarDia2019_sergioalbert_-02.webp';
import Membrane_20 from '../assets-optimized/projects/2019-Membrane/Membrane_20-Membrane-AR_00000.webp';
import Membrane_01 from '../assets-optimized/projects/2019-Membrane/Membrane_01-Membrane-MX.webp';
import Membrane_TodaysArt from '../assets-optimized/projects/2019-Membrane/Membrane_TodaysArt19_Push-1-stop_TAHS_Maurice-Mikkers-1873.webp';
import Membrane_O34A1124 from '../assets-optimized/projects/2019-Membrane/Membrane_O34A1124.webp';
import Membrane_126 from '../assets-optimized/projects/2019-Membrane/Membrane_126.webp';

// 2020-Previz
import PrevizGallery from '../assets-optimized/projects/2020-Previz/Previz_Previz_gallery_01.webp';
import PrevizCadie11 from '../assets-optimized/projects/2020-Previz/Previz_CadieDD_MichaelGD_Previs_11-scaled-1.webp';
import PrevizCadie5 from '../assets-optimized/projects/2020-Previz/Previz_CadieDD_MichaelGD_Previs_5.webp';
import PrevizCadie13 from '../assets-optimized/projects/2020-Previz/Previz_CadieDD_MichaelGD_Previs_13-scaled-1.webp';
import PrevizCadie02 from '../assets-optimized/projects/2020-Previz/Previz_CadieDD_MichaelGD_Previs_02.webp';
import PrevizCadie06 from '../assets-optimized/projects/2020-Previz/Previz_CadieDD_MichaelGD_Previs_06.webp';
import PrevizCadie12 from '../assets-optimized/projects/2020-Previz/Previz_CadieDD_MichaelGD_Previs_12.webp';
import PrevizCadie03 from '../assets-optimized/projects/2020-Previz/Previz_CadieDD_MichaelGD_Previs_03-1.webp';

// 2017-Liquid_Architecture
import LA_23004486 from '../assets-optimized/projects/2017-Liquid_Architecture/LA_23004486_10155604513175250_5445143496505114217_o.webp';
import LA_21083470 from '../assets-optimized/projects/2017-Liquid_Architecture/LA_21083470_10155612918622856_1179132426044374658_o.webp';
import LA_21985094 from '../assets-optimized/projects/2017-Liquid_Architecture/LA_21985094_1158824564219546_8532207693216088064_n.webp';
import LA_21122437 from '../assets-optimized/projects/2017-Liquid_Architecture/LA_21122437_10155413439120250_2315737827348369587_o.webp';
import LA_01clip from '../assets-optimized/projects/2017-Liquid_Architecture/LA_01-clip-1-t112-0-00-04-12-.webp';
import LA_wiklow from '../assets-optimized/projects/2017-Liquid_Architecture/LA_wiklow_diagraf_ewerex-liquid_architecture-MUTEK_MX-upscaled.webp';
import LA_AVision from '../assets-optimized/projects/2017-Liquid_Architecture/LA_AVision-1.webp';

// 2015-Skeletal_Wires
import SW_Wiklow from '../assets-optimized/projects/2015-Skeletal_Wires/SW_Wiklow-MUTEK01.webp';
import SW_176500 from '../assets-optimized/projects/2015-Skeletal_Wires/SW_17650058894_2e530e8cc8_o.webp';
import SW_Materials from '../assets-optimized/projects/2015-Skeletal_Wires/SW_Materials-01PaintedVinyl-e1603406504795.webp';
import SW_180849 from '../assets-optimized/projects/2015-Skeletal_Wires/SW_18084921490_6c1a8987eb_o-upscaled-straightened-2048x1366.webp';
import SW_180848 from '../assets-optimized/projects/2015-Skeletal_Wires/SW_18084871238_026e04a968_o.webp';

// ===================
// Lazy Components (unchanged)
// ===================

/**
 * LazyImage – This component does not set its “src” until it is in (or near) the viewport.
 */
const LazyImage = ({ src, alt, ...props }) => {
  const imgRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let observer;
    if (imgRef.current && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              observerInstance.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(imgRef.current);
    } else {
      // Fallback for unsupported browsers
      setIsVisible(true);
    }
    return () => {
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <img ref={imgRef} alt={alt} {...(isVisible ? { src } : {})} {...props} />
  );
};

/**
 * LazyIframe – This component waits to render the iframe until its container is visible.
 */
const LazyIframe = ({ src, title, ...props }) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let observer;
    if (containerRef.current && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              observerInstance.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(containerRef.current);
    } else {
      setIsVisible(true);
    }
    return () => {
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <div ref={containerRef}>
      {isVisible ? (
        <iframe src={src} title={title} {...props} />
      ) : (
        // Placeholder div to preserve aspect ratio
        <div style={{ paddingBottom: '56.25%' }} />
      )}
    </div>
  );
};


const ProjectTitle = ({ title, credits }) => (
  <div className="project-title-block">
    <h2>{title}</h2>
    {credits && <p>{credits}</p>}
  </div>
);

// ===================
// Home Component
// ===================

const Home = () => {
  // Fade in effect for the page wrapper
  useEffect(() => {
    const wrapper = document.getElementById('page-wrapper');
    if (wrapper) {
      setTimeout(() => {
        wrapper.style.opacity = '1';
      }, 10);
    }
  }, []);

  // Setup the sound toggle for the animated video
  useEffect(() => {
    const video = document.getElementById('animated-video');
    const toggleBtn = document.getElementById('toggle-sound');
    if (video && toggleBtn) {
      // Using require for SVG icons (not processed by Sharp)
      toggleBtn.style.backgroundImage = `url(${require('../assets/icons/video-player/icon-mute.svg').default})`;
      toggleBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        toggleBtn.style.backgroundImage = video.muted
          ? `url(${require('../assets/icons/video-player/icon-mute.svg').default})`
          : `url(${require('../assets/icons/video-player/icon-volume.svg').default})`;
      });
    }
  }, []);

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="hero full-screen">
        <div className="hero-content">{/* Optional hero text */}</div>
        <div className="scroll-indicator">Scroll Down</div>
      </section>

      <section id="media-feed">
      {/* Media Feed Section */}


{/* NEW PROJECT: Substrat (2025) */}
      <ProjectTitle 
        title="Substrat (2025)"
        credits={
          <>
            In collaboration with{' '}
            Freddy Speer. Photos by Frédérique Ménard-Aubin & Sébastien Roy.
          </>
        }
      />
      
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={MGD_FS_SAT61} alt="Substrat - Frédérique Ménard-Aubin SAT-61" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={MGD_FS_SAT71} alt="Substrat - Frédérique Ménard-Aubin SAT-71" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={MGD_FS_017} alt="Substrat - Sebastien Roy 017" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={MGD_FS_SAT60} alt="Substrat - Frédérique Ménard-Aubin SAT-60" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={MGD_FS_035} alt="Substrat - Sebastien Roy 035" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={MGD_FS_SAT85} alt="Substrat - Frédérique Ménard-Aubin SAT-85" />
        </div>
      </div>

      <ProjectTitle 
        title="Unsettled (2025)"
        credits={
          <>
            In collaboration with{' '}
            <a 
              href="https://www.lainebutler.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ textDecoration: 'underline', color: 'inherit' }}
            >
              Laine Butler
            </a>. Photos by Sébastien Roy.
          </>
        }
      />

      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={US_035} alt="Unsettled - Sebastien Roy 035" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={US_006} alt="Unsettled - Sebastien Roy 006" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={US_011} alt="Unsettled - Sebastien Roy 011" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={US_023} alt="Unsettled - Sebastien Roy 023" />
        </div>
      </div>
      <div className="media-slide">
        <div className="img-container">
          <LazyImage src={US_032} alt="Unsettled - Sebastien Roy 032" />
        </div>
      </div>



        <ProjectTitle 
          title="First/Breathe (2024)"
          credits="Co-Produced with Le Centre d'expérimentation musicale (CEM). Video by Bruno Destombes."
        />
        {/* Slide 1: Vimeo Video (16:9) */}
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/1049291897?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo Slide 1"
          />
        </div>

        {/* Slide 2: Animated Video with Sound Toggle (commented out) */}
        {/*
        <div className="media-slide video-slide">
          <video id="animated-video" autoPlay muted loop playsInline>
            <source src={require('../assets/videos/animated-content.mp4').default} type="video/mp4" />
            <source src={require('../assets/videos/2023-HERO-VIDEO-QUICK-CUT-v2.webm').default} type="video/webm" />
            Your browser does not support the video tag.
          </video>
          <button id="toggle-sound" className="video-sound-toggle" aria-label="Toggle sound"></button>
        </div>
        */}

        {/* Slide 3: Full-Width Image (CEM Cover Shot) */}
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={CEMMGDCoverShot} alt="CEM Cover Shot" />
          </div>
        </div>

        {/* Slide 4: Full-Width Image (CEM Cello 01) */}
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={CEMP1084386} alt="CEM Cello 01" />
          </div>
        </div>

        {/* Slide 5: Full-Width Image (CEM Players 01) */}
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={CEMStills} alt="CEM Players 01" />
          </div>
        </div>

        {/* Slide 6: Full-Width Image (CEM - 3gars) */}
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={CEM3gars} alt="CEM - 3gars" />
          </div>
        </div>

        {/* Slide 7: Full-Width Image (CEM) */}
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={CEMP1084604} alt="CEM Image" />
          </div>
        </div>

        {/* Slide 8: Full-Width Image (CEM) */}
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={CEMP1084477} alt="CEM Image" />
          </div>
        </div>

        {/* Slide 9: Vimeo Video (16:9) */}
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/1051744421?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo Slide 2"
          />
        </div>

        {/* Slide 10: YouTube Video (16:9) */}
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://www.youtube.com/embed/JZPa8Dg2Pn8?vq=hd1080"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube - Membrane"
          />
        </div>

        {/* FOREVER MEDITATIONS Slides */}
        <ProjectTitle 
  title="Forever Meditations (2023)"
  credits="Double Bass by Freddy Speer. Dolby Atmos version produced by Centre PHI. Photos by Sébastien Roy, Bruno Destombes."
/>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MUTEK24_001} alt="FM_MUTEK24_001 (13:51:02)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MUTEK24_007} alt="FM_MUTEK24_007 (13:49:09)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MUTEK24_005} alt="FM_MUTEK24_005 (13:49:23)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MG_9175} alt="FM_MG_9175 (13:49:34)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MG_9229} alt="FM_MG_9229 (13:49:48)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MG_9344} alt="FM_MG_9344 (13:49:55)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MG_9349} alt="FM_MG_9349 (13:50:02)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MG_9365} alt="FM_MG_9365 (13:50:07)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MUTEK24_016} alt="FM_MUTEK24_016 (13:50:14)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_MUTEK24_006} alt="FM_MUTEK24_006 (13:50:23)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_DSCF1480} alt="FM_DSCF1480 (13:50:29)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_DSCF1371} alt="FM_DSCF1371 (13:50:35)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_PhiCentreMixing2Vertical2} alt="FM_PhiCentreMixing2Vertical2 (13:50:41)" />
          </div>
        </div>
        {/*
          (Optional commented-out slide for FM_IMG_1733)
        */}
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_DSCF1414} alt="FM_DSCF1414 (13:50:52)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_StudioRehearsalVertical3} alt="FM_StudioRehearsalVertical3 (13:50:56)" />
          </div>
        </div>

        {/* NEW Media Slides for 2021-Abandoned_Pianos */}
        <ProjectTitle 
  title="Abandoned Pianos (2021)"
  credits="Banff Centre Artist-In-Residence. Video by Bruno Destombes."
/>
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/730832348?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Abandoned Pianos"
          />
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_ABANDONED_PIANS_1} alt="AP_ABANDONED_PIANS_1 (14:05:08)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_ABANDONED_PIANS_2} alt="AP_ABANDONED_PIANS_2 (14:06:22)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_ABANDONED_PIANS_3} alt="AP_ABANDONED_PIANS_3 (14:06:33)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_ABANDONED_PIANS_4} alt="AP_ABANDONED_PIANS_4 (14:06:42)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_MG_5753} alt="AP_MG_5753 (14:06:49)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_MG_5771} alt="AP_MG_5771 (14:06:55)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_PT200120} alt="AP_PT200120 (14:06:58)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_Promo06} alt="AP_Promo06 (14:07:04)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={AP_Promo09} alt="AP_Promo09 (14:07:09)" />
          </div>
        </div>
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/412101073?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Abandoned Pianos 2"
          />
        </div>

        {/* FROZEN MUSIC */}
        <ProjectTitle 
          title="Frozen Music (2020)"
          credits={
            <>
              In collaboration with{' '}
              <a 
                href="https://desbiens-desmeules.com" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ textDecoration: 'underline', color: 'inherit' }}
              >
                Cadie Desbiens-Desmeules
              </a>. Co-produced with LEV Festival.
            </>
          }
        />
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/798139025?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Frozen Music"
          />
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_01} alt="FM_FrozenMusic_01 (14:32:54)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_IMG7182} alt="FM_FrozenMusic_IMG7182 (14:32:58)" />
          </div>
        </div>
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/474025631?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Frozen Music 2"
          />
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_02} alt="FM_FrozenMusic_02 (14:33:01)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_03} alt="FM_FrozenMusic_03 (14:33:05)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_Portrait} alt="FM_FrozenMusic_Portrait (14:33:08)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_IMG1508} alt="FM_FrozenMusic_IMG1508 (14:33:11)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_119125342} alt="FM_FrozenMusic_119125342 (14:33:13)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_EhyEq} alt="FM_FrozenMusic_EhyEq (14:33:16)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={FM_FrozenMusic_SONCIA} alt="FM_FrozenMusic_SONCIA (14:33:18)" />
          </div>
        </div>
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/451818403?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Frozen Music 3"
          />
        </div>

        {/* MEMBRANE */}
        <ProjectTitle 
          title="Membrane (2019)"
          credits={
            <>
              <a 
                href="https://push1stop.com/" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ textDecoration: 'underline', color: 'inherit' }}
              >
                Push 1 stop
              </a>{' '}
              & Wiklow. Artist-In-Residences with GNRATION, Perte de signal.
            </>
          }
        />

        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={Membrane_Push1Stop} alt="Membrane_Push1Stop (15:42:18)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={Membrane_WiklowPush1Stop} alt="Membrane_WiklowPush1Stop (15:42:22)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={Membrane_20} alt="Membrane_20 (15:42:25)" />
          </div>
        </div>
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/742821819?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Membrane 2"
          />
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={Membrane_01} alt="Membrane_01 (15:42:27)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={Membrane_TodaysArt} alt="Membrane_TodaysArt (15:42:29)" />
          </div>
        </div>
        {/* Slide 7: YouTube Video (16:9) */}
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://www.youtube.com/embed/Fj2_ny9nIg4?vq=hd1080"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube - Membrane"
          />
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={Membrane_O34A1124} alt="Membrane_O34A1124 (15:42:32)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={Membrane_126} alt="Membrane_126 (15:42:34)" />
          </div>
        </div>
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/262103342?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Membrane 3"
          />
        </div>

        {/* PREVIZ */}
        <ProjectTitle 
        title="Previz (2020)"
        credits={
          <>
            In collaboration with{' '}
            <a 
              href="https://desbiens-desmeules.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ textDecoration: 'underline', color: 'inherit' }}
            >
              Cadie Desbiens-Desmeules
            </a>. Co-produced Contemporary Musiking Hong Kong.
          </>
        }
        />

        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/742824611?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Previz"
          />
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={PrevizGallery} alt="Previz Gallery (15:48:16)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={PrevizCadie11} alt="Previz Cadie 11 (15:48:26)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={PrevizCadie5} alt="Previz Cadie 5 (15:48:41)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={PrevizCadie13} alt="Previz Cadie 13 (15:48:47)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={PrevizCadie02} alt="Previz Cadie 02 (15:48:50)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={PrevizCadie06} alt="Previz Cadie 06 (15:48:52)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={PrevizCadie12} alt="Previz Cadie 12 (15:48:54)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={PrevizCadie03} alt="Previz Cadie 03 (15:48:56)" />
          </div>
        </div>
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/799650068?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Previz 2"
          />
        </div>

        {/* LIQUID ARCHITECTURE */}
        <ProjectTitle 
  title="Liquid Architecture (2017)"
  credits="Wiklow, Diagraf & Ewerx. Co-produced with La Société des arts technologiques."
/>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={LA_23004486} alt="LA_23004486 (16:03:33)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={LA_21083470} alt="LA_21083470 (16:03:37)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={LA_21985094} alt="LA_21985094 (16:03:40)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={LA_21122437} alt="LA_21122437 (16:03:42)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={LA_01clip} alt="LA_01clip (16:03:49)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={LA_wiklow} alt="LA_wiklow (16:03:56)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={LA_AVision} alt="LA_AVision (16:03:59)" />
          </div>
        </div>
        <div className="media-slide video-slide">
          <LazyIframe
            src="https://player.vimeo.com/video/340213930?title=0&byline=0&portrait=0"
            frameBorder="0"
            allowFullScreen
            title="Vimeo - Liquid Architecture"
          />
        </div>

        {/* SKELETAL WIRES */}
        <ProjectTitle 
          title="Skeletal Wires (2015)"
          credits="Visuals by Diagraf."
        />

        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={SW_Wiklow} alt="SW_Wiklow (Skeletal Wires - Wiklow MUTEK)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={SW_176500} alt="SW_176500 (Skeletal Wires Image 1)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={SW_Materials} alt="SW_Materials (Skeletal Wires Materials)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={SW_180849} alt="SW_180849 (Skeletal Wires Image 3 - Straightened)" />
          </div>
        </div>
        <div className="media-slide">
          <div className="img-container">
            <LazyImage src={SW_180848} alt="SW_180848 (Skeletal Wires Image 2)" />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
